import React from "react";
import { MemoryRouter, Routes, Route } from "react-router-dom";
import Start_menu from "./components/Start_menu/Start_menu.js";
import Qzero from "./components/qzero/qzero.js";
import "./App.scss";

const App = () => {
  return (
    <MemoryRouter>
      <Routes>
        <Route path="/" element={<Start_menu />} />
        <Route path="/:type" element={<Qzero key={"qzero"} />} />
      </Routes>
    </MemoryRouter>
  );
};

export default App;